import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "../modal/modal.scss";
import TableContainer from "@material-ui/core/TableContainer";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import Loader from "../Loader/Loader";
import Tablestyles from "../../screens/Mapping/ROCITable.module.css";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  body: {
    fontSize: 12,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

const Row = ({ keys, rowData, headingRow }) => {
  let data = rowData;

  const getColorCode = () => {
    if (!data) return "transparent";
    if (data?.ISDELETED) return "rgba(255, 0, 0, 1)";
    if (data?.ISNEW) return "rgba(235, 54, 127, 1)";
    if (data?.ISEDITED) return "rgba(13, 110, 253, 1)";
    return "#46596a";
  };

  const formatArrayForUI = (arr) => {
    if (arr.length === 0) return "";
    return arr
      .map(
        (obj, index) =>
          `${index + 1}. ` +
          Object.entries(obj)
            .map(([key, value]) => `${key}: ${value}`)
            .join(" | ")
      )
      .join("\n");
  };

  const isLongValue = (value) => {
    if (value === null || value === "null") {
      return false;
    }

    // String or Array → check length
    if (typeof value === "string") {
      return value.length > 40;
    }

    // Object → check number of keys
    if (typeof value === "object") {
      return Object.keys(value).length > 0 && JSON.stringify(value).length > 40;
    }

    if (typeof value === "array") {
      const Stringed_Array = formatArrayForUI(value);
      return Stringed_Array && Stringed_Array.length > 30;
    }

    return false;
  };

  return (
    <TableRow
      key={`Rowkey-${keys}`}
      className={"table-row"}
      style={{ cursor: "pointer" }}
      // style={{ cursor: "pointer", backgroundColor: getColorCode() }}
    >
      {headingRow.map((item, index) => {
        return (
          <StyledTableCell
            key={`key-${index}`}
            className={""}
            style={{ cursor: "pointer" }}
          >
            {item.name !== "status" ? (
              <div
                className="scrollable-cell cell-wrapper"
                style={{
                  position: "relative",
                  height: "40px",
                  padding: "2px 3px",
                  border: isLongValue(data?.[item.name])
                    ? "1px solid #e0e0e0"
                    : "none",
                  overflowY: isLongValue(data?.[item.name])
                    ? "scroll"
                    : "visible",
                  whiteSpace: "nowrap",
                  // display: "block",
                  textWrap: "wrap",
                  display: "flex",
                  alignItems: isLongValue(data?.[item.name])
                    ? "start"
                    : "center",
                }}
              >
                {data[item.name] && typeof data[item.name] === "object"
                  ? JSON.stringify(data[item.name])
                  : Array.isArray(data[item.name])
                  ? JSON.stringify(data[item.name], null, 2)
                  : data[item.name] || "None"}
              </div>
            ) : (
              <div
                className="scrollable-cell cell-wrapper"
                style={{
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "transparent",
                  padding: "2px 3px",
                  border: isLongValue(data?.[item.name])
                    ? "1px solid #e0e0e0"
                    : "none",
                  color: getColorCode() || "",
                  fontWeight: "600",
                  borderRadius: "4px",
                }}
              >
                {data?.ISDELETED && <span>DELETED</span>}
                {!data?.ISDELETED && data?.ISNEW && <span>NEW</span>}
                {!data?.ISDELETED && data?.ISEDITED && <span>EDITED</span>}
                {!data?.ISDELETED && !data?.ISNEW && !data?.ISEDITED && (
                  <span>NOT EDITED</span>
                )}
              </div>
            )}
          </StyledTableCell>
        );
      })}
    </TableRow>
  );
};

export default function ApprovalModal(props) {
  const {
    sourceData,
    openModal,
    closeModel,
    isTableLoading,
    tableData,
    approvalTableHeaders,
  } = props;
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginatedRows, setPaginatedRows] = useState([]);
  const [sortedTableData, setSortedTableData] = useState([]);
  const [sortedApprovalTableHeaders, setSortedApprovalTableHeaders] = useState(
    []
  );

  const hasAllFlags = tableData.every(
    (item) => "ISDELETED" in item && "ISNEW" in item && "ISEDITED" in item
  );

  const handleClose = () => {
    setOpen(false);
    closeModel();
  };

  const handlePaginatedRows = (newPage) => {
    const start = newPage * rowsPerPage;
    const end = start + rowsPerPage;
    const currentPageRows = sortedTableData.slice(start, end);
    return currentPageRows;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const Paginated_Rows = handlePaginatedRows(newPage);
    setPaginatedRows(Paginated_Rows);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value);
    setRowsPerPage(value);
    const start = 0 * value;
    const end = start + value;
    const currentPageRows = sortedTableData.slice(start, end);
    setPaginatedRows(currentPageRows);
    setPage(0);
  };

  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  // headers
  useEffect(() => {
    if (!approvalTableHeaders?.length) return;

    setSortedApprovalTableHeaders(
      hasAllFlags
        ? [...approvalTableHeaders, { label: "Status", name: "status" }]
        : approvalTableHeaders
    );
  }, [tableData, approvalTableHeaders, hasAllFlags]);

  useEffect(() => {
    const hasValidTableData =
      tableData && Array.isArray(tableData) && tableData.length > 0;

    if (!hasValidTableData) {
      setPaginatedRows([]);
      return;
    }

    // TABLE DATA SORT
    const getPriority = (item) => {
      if (item.ISDELETED) return 1;
      if (item.ISNEW) return 2;
      if (item.ISEDITED) return 3;
      return 4;
    };

    const TableData = hasAllFlags
      ? [...tableData].sort((a, b) => getPriority(a) - getPriority(b))
      : tableData;
    setSortedTableData(TableData);
    setPaginatedRows(TableData.slice(0, rowsPerPage));
  }, [tableData, approvalTableHeaders, hasAllFlags]);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"xl"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Table Records</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {isTableLoading && <Loader />}
            {!isTableLoading &&
              sortedTableData &&
              sortedTableData.length > 0 && (
                <>
                  <TableContainer className={Tablestyles.budget_tb3}>
                    <Table stickyHeader>
                      <TableHead className="table-heading">
                        <TableRow>
                          {sortedApprovalTableHeaders.map((item, i) => (
                            <StyledTableCell key={i}>
                              {item.label}
                            </StyledTableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paginatedRows.map((row, index) => (
                          <Row
                            keys={index}
                            rowData={row}
                            headingRow={sortedApprovalTableHeaders}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* PAGINATION */}
                  {sortedTableData.length > 0 && (
                    <div>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={sortedTableData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div>
                  )}
                </>
              )}

            {!isTableLoading && !sortedTableData.length && (
              <div style={{ textAlign: "center", marginTop: "10px" }}>
                No Data Found.
              </div>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
